import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ContactForm() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
    try {
      const res = await fetch('https://readdy.ai/api/form/d7oeeopuelgcie28i180', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      if (res.ok) {
        setSubmitted(true);
        form.reset();
      }
    } catch {
      alert('送出失敗，請稍後再試或直接來電聯繫。');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact-form" className="bg-[#F8F5F0] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-14 items-start">

          {/* Left: Form */}
          <div className="w-full lg:w-[60%]">
            <p className="text-[#D4A373] font-semibold tracking-widest mb-3" style={{ fontSize: '1rem' }}>
              SEND A MESSAGE
            </p>
            <h2
              className="font-serif font-bold text-[#5C5470] mb-4"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
            >
              留言給保險建築師
            </h2>
            <div className="w-14 h-1 bg-[#D4A373] rounded-full mb-8"></div>

            {submitted ? (
              <div className="bg-white rounded-3xl p-12 text-center border border-[#D4A373]/30">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#D4A373]/15 mx-auto mb-5">
                  <i className="ri-check-double-line text-[#D4A373] text-3xl"></i>
                </div>
                <h3
                  className="font-serif font-bold text-[#5C5470] mb-3"
                  style={{ fontSize: 'clamp(1.25rem, 2vw, 1.625rem)', lineHeight: '1.45' }}
                >
                  已收到您的諮詢需求！
                </h3>
                <p className="text-gray-600 mb-6" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
                  琮恩將在 1–2 個工作天內與您聯繫，感謝您的信任。
                </p>
                <button
                  onClick={() => setSubmitted(false)}
                  className="inline-flex items-center gap-2 border-2 border-[#5C5470] text-[#5C5470] px-6 py-3 rounded-full font-semibold whitespace-nowrap hover:bg-[#5C5470] hover:text-white transition-all duration-200 cursor-pointer"
                  style={{ fontSize: '1.0625rem' }}
                >
                  再次填寫
                </button>
              </div>
            ) : (
              <form
                data-readdy-form
                action="https://readdy.ai/api/form/d7oeeopuelgcie28i180"
                method="POST"
                onSubmit={handleSubmit}
                className="bg-white rounded-3xl p-8 lg:p-10 space-y-6 border border-gray-100"
                style={{ boxShadow: '0 2px 20px 0 rgba(92,84,112,0.06)' }}
              >
                {/* Name + Phone */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>
                      姓名 <span className="text-[#FF8C69]">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      required
                      placeholder="您的姓名"
                      className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors"
                      style={{ fontSize: '1.0625rem' }}
                    />
                  </div>
                  <div>
                    <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>
                      電話 <span className="text-[#FF8C69]">*</span>
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      required
                      placeholder="09XX-XXX-XXX"
                      className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors"
                      style={{ fontSize: '1.0625rem' }}
                    />
                  </div>
                </div>

                {/* Email + LINE */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>
                      Email <span className="text-gray-400 font-normal">（選填）</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      placeholder="your@email.com"
                      className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors"
                      style={{ fontSize: '1.0625rem' }}
                    />
                  </div>
                  <div>
                    <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>
                      LINE ID <span className="text-gray-400 font-normal">（選填）</span>
                    </label>
                    <input
                      type="text"
                      name="line_id"
                      placeholder="您的 LINE ID"
                      className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors"
                      style={{ fontSize: '1.0625rem' }}
                    />
                  </div>
                </div>

                {/* Topic */}
                <div>
                  <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>
                    目前最想了解的主題
                  </label>
                  <select
                    name="topic"
                    className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors bg-white cursor-pointer"
                    style={{ fontSize: '1.0625rem' }}
                  >
                    <option value="">請選擇</option>
                    <option value="個人醫療保險">個人醫療保險</option>
                    <option value="家庭保障規劃">家庭保障規劃</option>
                    <option value="長期照護與退休準備">長期照護與退休準備</option>
                    <option value="保單健檢">保單健檢</option>
                    <option value="企業與團體方案">企業與團體方案</option>
                    <option value="其他需求">其他需求</option>
                  </select>
                </div>

                {/* Budget */}
                <div>
                  <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>
                    預算或目前保費狀況
                  </label>
                  <select
                    name="budget"
                    className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors bg-white cursor-pointer"
                    style={{ fontSize: '1.0625rem' }}
                  >
                    <option value="">請選擇</option>
                    <option value="尚未投保">尚未投保</option>
                    <option value="已有保單，想做健檢">已有保單，想做健檢</option>
                    <option value="每月 3000 元以下">每月 3,000 元以下</option>
                    <option value="每月 3000–6000 元">每月 3,000–6,000 元</option>
                    <option value="每月 6000 元以上">每月 6,000 元以上</option>
                    <option value="希望先諮詢再評估">希望先諮詢再評估</option>
                  </select>
                </div>

                {/* Message */}
                <div>
                  <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>
                    留言
                  </label>
                  <textarea
                    name="message"
                    rows={4}
                    maxLength={500}
                    placeholder="請簡單描述您目前的擔心、想守護的人，或想檢視的保單問題。"
                    className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors resize-none"
                    style={{ fontSize: '1.0625rem' }}
                  ></textarea>
                  <p className="text-gray-400 mt-1 text-right" style={{ fontSize: '1rem' }}>最多 500 字</p>
                </div>

                {/* Submit */}
                <button
                  type="submit"
                  disabled={submitting}
                  className={`w-full py-4 rounded-full font-semibold whitespace-nowrap transition-all duration-200
                    ${submitting ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#D4A373] text-white hover:bg-[#c4935f] hover:scale-[1.02] cursor-pointer'}`}
                  style={{ fontSize: '1.1875rem' }}
                >
                  {submitting ? '送出中…' : '送出諮詢需求'}
                </button>

                {/* Disclaimer */}
                <p className="text-gray-400 text-center" style={{ fontSize: '1rem', lineHeight: '1.7' }}>
                  送出資料不代表完成投保或保證承保，實際保障內容仍需依個人需求、健康狀況與保險公司核保規定評估。
                </p>
              </form>
            )}
          </div>

          {/* Right: LINE + Download */}
          <div className="w-full lg:w-[40%] flex flex-col gap-7">
            {/* LINE Card */}
            <div className="bg-[#5C5470] rounded-3xl p-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/15 mb-5">
                <i className="ri-line-fill text-white text-2xl"></i>
              </div>
              <h3
                className="font-serif font-bold text-white mb-3"
                style={{ fontSize: 'clamp(1.25rem, 2vw, 1.625rem)', lineHeight: '1.45' }}
              >
                想先用 LINE 問問題也可以
              </h3>
              <p className="text-white/75 mb-6" style={{ fontSize: '1.0625rem', lineHeight: '1.75' }}>
                如果您還沒有準備好填表，也可以先加入 LINE，簡單說明目前的保障需求、保單疑問或家庭風險狀況，我會協助您釐清下一步。
              </p>
              <p className="text-white/90 font-semibold mb-1" style={{ fontSize: '1rem', lineHeight: '1.75' }}>
                LINE@ ID：@031gzncd
              </p>
              <a
                href="https://lin.ee/6XFYSq2"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-white text-[#5C5470] px-6 py-3.5 rounded-full font-semibold whitespace-nowrap hover:bg-[#D4A373] hover:text-white transition-all duration-200 w-full"
                style={{ fontSize: '1.0625rem' }}
                aria-label="加入 LINE 諮詢"
              >
                <i className="ri-line-fill"></i>
                加入 LINE 諮詢
              </a>
            </div>

            {/* Download Card */}
            <div className="bg-white rounded-3xl p-8 border border-gray-100" style={{ boxShadow: '0 2px 16px 0 rgba(92,84,112,0.06)' }}>
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#D4A373]/15 mb-5">
                <i className="ri-download-line text-[#D4A373] text-2xl"></i>
              </div>
              <h3
                className="font-serif font-bold text-[#5C5470] mb-3"
                style={{ fontSize: 'clamp(1.25rem, 2vw, 1.625rem)', lineHeight: '1.45' }}
              >
                先下載保單健檢表
              </h3>
              <p className="text-gray-600 mb-6" style={{ fontSize: '1.0625rem', lineHeight: '1.75' }}>
                整理自己的保障現況，不知道該問什麼沒關係，先把既有保單與家庭責任整理出來，下一步會更清楚。
              </p>
              <Link
                to="/tools#download-section"
                className="inline-flex items-center justify-center gap-2 border-2 border-[#D4A373] text-[#D4A373] px-6 py-3.5 rounded-full font-semibold whitespace-nowrap hover:bg-[#D4A373] hover:text-white transition-all duration-200 w-full"
                style={{ fontSize: '1.0625rem' }}
              >
                <i className="ri-file-search-line"></i>
                下載保單健檢表
              </Link>
            </div>

            {/* Service Methods */}
            <div className="bg-[#F8F5F0] rounded-3xl p-8 border border-gray-100">
              <h3
                className="font-serif font-bold text-[#5C5470] mb-5"
                style={{ fontSize: 'clamp(1.125rem, 1.5vw, 1.375rem)', lineHeight: '1.45' }}
              >
                服務方式
              </h3>
              <ul className="space-y-3">
                {[
                  { icon: 'ri-video-chat-line', text: '線上一對一諮詢' },
                  { icon: 'ri-file-search-line', text: '保單健檢服務' },
                  { icon: 'ri-home-heart-line', text: '家庭保障規劃' },
                  { icon: 'ri-building-4-line', text: '企業團體方案洽詢' },
                ].map((item) => (
                  <li key={item.text} className="flex items-center gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#D4A373]/15 flex-shrink-0">
                      <i className={`${item.icon} text-[#D4A373]`} style={{ fontSize: '1.0625rem' }}></i>
                    </div>
                    <span className="text-gray-700 font-medium" style={{ fontSize: '1.0625rem' }}>{item.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
